import {createContext, useMemo, useState, useEffect} from 'react';
import {debounce} from 'lodash';

const AdvancedFiltersContext = createContext({});
const AdvancedFiltersProvider  = ({children, filters, onFiltersChange, debounceTimeInMs }) => {
    const [internalFilters, setInternalFilters] = useState(filters);

    useEffect(() => {
        setInternalFilters(filters);
    }, [filters]);

    const debounceFiltersChange = useMemo(() =>
            debounce((filters) => onFiltersChange(filters), debounceTimeInMs),
        [onFiltersChange, debounceTimeInMs]
    )

    const handleSetFilters = (newFilters) => {
        setInternalFilters(newFilters);
        debounceFiltersChange(newFilters);
    }

    return (
        <AdvancedFiltersContext.Provider value={{filters: internalFilters, setFilters: handleSetFilters, debounceFiltersChange}}>
            {children}
        </AdvancedFiltersContext.Provider>
    )
}

export { AdvancedFiltersContext, AdvancedFiltersProvider };
